/**
 * @generated SignedSource<<a868c4b632cf7824d9b5c601deede86f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceSettingsBody_viewer$data = {
  readonly me: {
    readonly is_employee: boolean;
  };
  readonly " $fragmentType": "PieceSettingsBody_viewer";
};
export type PieceSettingsBody_viewer$key = {
  readonly " $data"?: PieceSettingsBody_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PieceSettingsBody_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PieceSettingsBody_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "is_employee",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MusicViewer",
  "abstractKey": null
};

(node as any).hash = "c365e4eea6612884e6000f66570d8ef9";

export default node;
